import { Grid, Box, Typography, Button, CircularProgress } from "@mui/material";
import UploadIcon from "./../../assets/svgIcons/upload.svg";
import Eyecon from "./../../assets/svgIcons/eye.svg";
import { isUploadOptionShow } from "../../utils/helpers";
import { useSelector } from "react-redux";
import { RootState } from "../../services/redux/store";

interface PropTypes {
  item: any;
  isXsOrSm: any;
  handleUploadDocument: (
    val1: any,
    val2: any,
    bankName?: any,
    categoryName?: string
  ) => void;
  partnerStartedJourney: any;
  categoryName?: string;
  canReUpload?: boolean;
  uploadDocumentLoader: any;
  handlePreviewDocument: (value: any) => void;
  userDoc: any;
  isLoadingButton?: boolean;
  docSecName: string;
}

const ManualBankStatement = ({
  item,
  isXsOrSm,
  handleUploadDocument,
  partnerStartedJourney,
  categoryName,
  canReUpload = true,
  uploadDocumentLoader,
  userDoc,
  handlePreviewDocument,
  isLoadingButton,
  docSecName
}: PropTypes) => {
  const { fetchUserApplicationData } = useSelector(
      (state: RootState) => state.stepper
  );
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
        backgroundColor: "#fff",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                color: "#1F2233",
              }}
            >
              {item?.docName} {userDoc?.bankName === "manual_bank_statement" ? null : userDoc.bankName}{" "}
              {item.isMandatory && <span style={{ color: "red" }}>*</span>}
            </Typography>

            {/* mobile only  */}
            {isXsOrSm && (
              <Box
                sx={{
                  backgroundColor:
                    item?.userDocs?.length > 0
                      ? "rgba(40, 199, 111, 0.16)"
                      : "#ffebee",
                  color:
                    item?.userDocs?.length > 0
                      ? "rgba(40, 199, 111, 1)"
                      : "#d32f2f",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: 500,
                  textTransform: "uppercase",
                }}
              >
                {item?.userDocs?.length > 0 ? "Uploaded" : "Pending"}
              </Box>
            )}
          </Box>

          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              lineHeight: 1.4,
            }}
          >
            {item?.description}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={2}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* desktop only  */}
          {!isXsOrSm && (
            <Box
              sx={{
                backgroundColor:
                  item?.userDocs?.length > 0
                    ? "rgba(40, 199, 111, 0.16)"
                    : "#ffebee",
                color:
                  item?.userDocs?.length > 0
                    ? "rgba(40, 199, 111, 1)"
                    : "#d32f2f",
                px: 1.5,
                py: 0.5,
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: 500,
                textTransform: "uppercase",
              }}
            >
              {item?.userDocs?.length > 0 ? "Uploaded" : "Pending"}
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mt: isXsOrSm ? 1 : 0,
              ml:isXsOrSm ? 0 : 1,
              width: { xs: "100%", sm: "auto" }
            }}
          >
            {canReUpload && isUploadOptionShow(docSecName, fetchUserApplicationData?.status) ? (
              <Button
                variant="outlined"
                startIcon={
                  <img
                    src={UploadIcon}
                    alt="Upload"
                    style={{
                      height: 16,
                      width: 16,
                    }}
                  />
                }
                onClick={() => {
                  handleUploadDocument(
                    item?.id,
                    item,
                    userDoc?.bankName,
                    categoryName,
                  );
                }}
                sx={{
                  textTransform: "none",
                  borderColor: "#00b3b5",
                  color: "#00b3b5",
                  "&:hover": {
                    borderColor: "#00999a",
                    bgcolor: "#e0f7fa",
                  },
                  px: 2,
                  py: 0.5,
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: 500,
                  minWidth: "auto",
                  whiteSpace: "nowrap",
                }}
                disabled={uploadDocumentLoader.includes(item?.id)}
              >
                {uploadDocumentLoader.includes(item?.id) ? (
                  <CircularProgress size={16} />
                ) : (
                  "Re-Upload"
                )}
              </Button>
            ): null}

            <Button
              startIcon={
                <img
                  src={Eyecon}
                  alt="View"
                  style={{
                    height: 16,
                    width: 16,
                  }}
                />
              }
              onClick={() => {
                const docUrl = userDoc?.docUrl;
                handlePreviewDocument(docUrl);
              }}
              sx={{
                textTransform: "none",
                borderColor: "#00b3b5",
                border: { xs: "1px solid", sm: "none" },
                color: "#00b3b5",
                "&:hover": {
                  borderColor: "#00999a",
                  bgcolor: "#e0f7fa",
                },
                px: 2,
                py: 0.5,
                mt: isXsOrSm ? 0 : 0,
                fontSize: "14px",
                fontWeight: 500,
                minWidth: "auto",
                whiteSpace: "nowrap",
                // remove border and hover effects when the button is disabled
                "&.Mui-disabled": {
                  border: { xs: "1px solid #9e9e9e", sm: "none" },
                  borderColor: "transparent",
                  bgcolor: "transparent",
                  color: "#9e9e9e",
                  "&:hover": {
                    border: "none",
                    bgcolor: "transparent",
                  },
                  // dim the icon when disabled
                  "& img": {
                    opacity: 0.5,
                  },
                },
              }}
            >
              {isLoadingButton
              ? "Loading..."
              : "View"}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ManualBankStatement;
